/**
 * Small helper for kicking off a blob download in the browser.
 * Used by the Stats view export buttons.
 */

/** Trigger a download of an arbitrary Blob / String with a filename. */
export function downloadBlob(content, filename, mime = "application/octet-stream") {
  const blob =
    content instanceof Blob ? content : new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  window.setTimeout(() => {
    URL.revokeObjectURL(url);
    a.remove();
  }, 500);
}

/**
 * Fetch a URL and trigger a browser download with a friendly filename.
 * The server sets Content-Disposition too, but forcing a client-side
 * anchor download gives us a reliable UX even with third-party proxies
 * that strip the header.
 */
export async function downloadFromUrl(url, filename) {
  const res = await fetch(url, { credentials: "omit" });
  if (!res.ok) {
    throw new Error(`Download failed: ${res.status}`);
  }
  const blob = await res.blob();
  downloadBlob(blob, filename, blob.type || "application/octet-stream");
}
